import { FORMAT_DEFINITIONS } from './constants';
import { calculateFormatOutput, getRemainingKegsForFormat } from './scenarioCalculations';
import { formatCurrency } from './formatters';
import { BottleIcon, CanIcon, JugIcon, KegIcon } from './icons';

const CHECK_ICON = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

const getFormatIcon = (formatId) => {
    if (formatId === 'cans_rtd') return CanIcon;
    if (formatId === 'keg_5gal_rtd') return KegIcon;
    if (formatId === 'gallon_conc') return JugIcon;
    return BottleIcon;
};

const WizardStep2Format = ({
    selectedFamily,
    selectedFormatId,
    availableKegs,
    formatAllocations,
    activeProductId,
    onSelectFormat,
}) => {
    const familyFormats = Object.values(FORMAT_DEFINITIONS).filter(fmt =>
        selectedFamily === 'rtd' ? fmt.is_rtd : !fmt.is_rtd
    );

    return (
        <div className="gsp-wizard-step gsp-step2 gsp-animate-in">
            <div className="gsp-step-section-header">
                <span className="gsp-step-num-badge">2</span>
                <div>
                    <h2 className="gsp-step-title">Choose the exact format</h2>
                    <p className="gsp-step-subtitle">
                        The selected family reveals only its formats. Select one to open the input.
                    </p>
                </div>
            </div>

            <div className="gsp-format-grid">
                {familyFormats.map(fmt => {
                    const Icon = getFormatIcon(fmt.id);
                    const isSelected = selectedFormatId === fmt.id;
                    const kegsForFormat = getRemainingKegsForFormat(
                        formatAllocations, activeProductId, fmt.id, availableKegs
                    );
                    const output = calculateFormatOutput(kegsForFormat, fmt.id);

                    return (
                        <button
                            key={fmt.id}
                            className={`gsp-format-card ${isSelected ? 'selected' : ''}`}
                            onClick={() => onSelectFormat(fmt.id)}
                            aria-pressed={isSelected}
                        >
                            {isSelected && (
                                <span className="gsp-card-checkmark">{CHECK_ICON}</span>
                            )}

                            <div className="gsp-format-card-top">
                                <div className="gsp-format-icon">
                                    <Icon />
                                </div>
                                <div className="gsp-format-card-heading">
                                    <strong>{fmt.name}</strong>
                                    <span>{fmt.per_concentrate_keg} {fmt.unit} per concentrate keg</span>
                                </div>
                            </div>

                            <div className="gsp-format-card-metrics">
                                <div className="gsp-format-metric">
                                    <span>Target</span>
                                    <strong>
                                        {availableKegs.toFixed(2)} / {availableKegs.toFixed(2)}
                                    </strong>
                                </div>
                                <div className="gsp-format-metric">
                                    <span>Est. Output</span>
                                    <strong>
                                        {Math.floor(output.units).toLocaleString()} {fmt.unit}
                                    </strong>
                                </div>
                                <div className="gsp-format-metric">
                                    <span>Est. Revenue</span>
                                    <strong>{formatCurrency(output.wsRevenue)}</strong>
                                </div>
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default WizardStep2Format;
